import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionBillingAddress } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  salesOrderPaymentTable,
  salesOrderScheduleTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Tabs, Tab, CircularProgress } from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function InvoiceBilling() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (user.token) {
      getTransactionBillingAddressData();
    }
  }, [user.token]);

  async function getTransactionBillingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionBillingAddress(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([])
  }

 return loading ? (
       <>
         <Box className="viewBox">
           <Box className="viewDetilsBox">
             <Grid container className="mb-2">
               <Grid item xs={12}>
                 <div
                   style={{
                     width: "100%",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                   }}
                 >
                   <CircularProgress></CircularProgress>
                 </div>
               </Grid>
             </Grid>
           </Box>
         </Box>
       </>
     ) : (
    <>
      {rowData?.map((el, index) => (
        <Box className="viewDetilsBox" key={index}>
          <Grid container className="mb-2" spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container>
                <Grid item xs={12} sm={6} md={4}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} className="m-b-10">
                      <p className="titleHeading">Billing Information</p>
                      <p className="tFormlabel">PAYMENT TERMS</p>
                      <p className="tFormName">{el?.payment_terms}</p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={8}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} className="m-b-10">
                      <p className="titleHeading">Billing Address</p>
                      <p className="tFormlabel">BILL TO</p>
                      <p className="tFormName">{el.vendor}<span style={{color:"#009de2"}}>{" "}Map</span></p>
                    </Grid>
                   
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
           
          </Grid>
        </Box>
      ))}
    </>
  );
}
